export const ACCESS_CODES = ['111222'];
